<template>
  <div style="width: 100%" ref="carousel">
    <el-carousel :height="carouseHeight" class="showImg" :interval="5000" arrow="always">
      <el-carousel-item>
<!--        <img class="background" src="../../../static/img/home/showImg01.jpg"/>-->
        <img class="background" :height="carouseHeight" src="../../../static/img/home/showImg01.jpg"/>
      </el-carousel-item>
      <!--      <el-carousel-item v-for="item in 4" :key="item">-->
      <!--        <h3>{{ item }}</h3>-->
      <!--      </el-carousel-item>-->
    </el-carousel>
  </div>
</template>

<script>
    export default {
        name: "homeShow",
        data() {
            return {
                carouseHeight: ""
            }
        },
        mounted() {
            // let carousel_Height = window.getComputedStyle(this.$refs.carousel).height;
            // let height = window.screen.availHeight;
            let height = document.documentElement.clientHeight;
            height -= 80;
            console.log(typeof (window.screen.availHeight));
            console.log(height);
            console.log(height.toString());
            this.carouseHeight = height.toString() + "px";
            console.log(this.carouseHeight)
        }
    }
</script>

<style scoped>
  .el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    line-height: 300px;
    margin: 0;

    height: auto !important;
    min-height: 344px;
  }

  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }

  .showImg{
    background-size: cover;
    text-align:center;
    vertical-align:middle
  }

  .background{
    text-align:center;
    vertical-align:middle;
    object-fit: cover;
    width: 100%;

    /*background-repeat: no-repeat;*/
    /*background-position: center center;*/

    /*display: flex;*/
    /*justify-content: center;*/
    /*align-items: center;*/
  }
</style>



// WEBPACK FOOTER //
// src/pages/Home/homeShow.vue